import { Input, Select, SelectItem } from "@heroui/react";
import { FilterCard } from "@/components/data-table";

const FilterData = ({ table, initialFilters = {}, filterOptions = {} }) => {
    const { types = [] } = filterOptions;
    const { pending, setPending, isOpen, apply, clear } = table.filterPanel;

    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            <Input
                label="No. Akun"
                placeholder="Cari No. Akun"
                variant="flat"
                isClearable
                value={pending.account_code || ""}
                onValueChange={(value) =>
                    setPending((prev) => ({ ...prev, account_code: value }))
                }
            />
            <Input
                label="Nama Akun"
                placeholder="Cari Nama Akun"
                variant="flat"
                isClearable
                value={pending.name || ""}
                onValueChange={(value) =>
                    setPending((prev) => ({ ...prev, name: value }))
                }
            />
            <Select
                label="Tipe Akun"
                placeholder="Pilih Tipe"
                variant="flat"
                selectedKeys={
                    pending.journal_account_type_id
                        ? [String(pending.journal_account_type_id)]
                        : []
                }
                onChange={(e) =>
                    setPending((prev) => ({
                        ...prev,
                        journal_account_type_id: e.target.value,
                    }))
                }
            >
                {types.map((type) => (
                    <SelectItem key={type.value} value={type.value}>
                        {type.title}
                    </SelectItem>
                ))}
            </Select>
        </FilterCard>
    );
};

export default FilterData;
